import { keysToCamelCase } from "zod-to-camel-case";

import type {
  EntityState,
  EntityStateCamel,
} from "@/schema/internal/entity_state/entity_state.schema";

export const entityStateFixture = ({
  overrides = {},
}: {
  overrides?: Partial<EntityState>;
} = {}): EntityState => ({
  entity_id: 1,
  entity_type: "lesson",
  entity_status: "api_neutral",
  last_error_location: null,
  last_error_message: null,
  last_error_timestamp: null,
  last_ingest_id: null,
  created_at: "2025-01-01T00:00:00.000Z",
  updated_at: "2025-01-01T00:00:00.000Z",
  ...overrides,
});

export const entityStateFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<EntityStateCamel>;
} = {}): EntityStateCamel => ({
  ...keysToCamelCase(entityStateFixture()),
  ...overrides,
});
